import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Grid from "@material-ui/core/Grid";
import { format } from "date-fns";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DynamicForm from "f1-dynamic-form-react";
import CloseIcon from "@mui/icons-material/Close";

import "./card.scss";
import { FILTER_FORM } from "../../pages/formData";
import Paper from "@material-ui/core/Paper";
import Pagination from '@material-ui/lab/Pagination';
import Typography from "@material-ui/core/Typography";
import {
  ApiUrls
} from "../../api/baseURL";
import { post } from "../../api/api";
import Loader from "../loader/loader";
import useOnlineStatus from "../../useOnlineStatus";
import { metaDataConstants } from "../../utils/Constants/constants-en";
import { getDateWithFormat } from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  drawerMobile: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  desktopFilter: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

function ProductListing(props) {
  const classes = useStyles();
  const [state, setState] = useState({ top: false });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const [totalProductCount, setTotalProductCount] = useState([]);
  const resetFilters = () => {
    setActivateLoader(true);

    const copyFormData = [...candidateDetail];
    copyFormData[1].options = [];
    copyFormData[2].options = [];
    setCandidateDetail(copyFormData);
    setCurrent({
      account: "null",
      location: "",
      storageArea: "",
    });
    setTotalProductCount([]);
    setLabelData({
      accountName: null,
      locationName: null,
      storageName: null
    })
    setActivateLoader(false);
  };

  const [activateLoader, setActivateLoader] = useState(false);
  const [candidateDetail, setCandidateDetail] = useState(FILTER_FORM);
  const [LocationData, setLocationData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [storageData, setStorageData] = useState([]);
  const [startDate, setStarDate] = useState(null);
  const [current, setCurrent] = useState({
    account: "null",
    location: null,
    storageArea: null,
  });
  const isOnline = useOnlineStatus();
  const [labelData, setLabelData] = useState({
    accountName: null,
    storageName: null,
    locationName: null,
  });
  const [inventoryCheckId, setInventoryCheckId] = useState(null);
  const [accounId, setAccountId] = useState(0);
  const [pageNumber, setPageNumber] = useState(1)
  const [showOfflineText, setShowOfflineText] = useState(true)
  const recordPerPage = 10;
  const coursesVisited = pageNumber * recordPerPage - recordPerPage;
  const coursePages = Math.ceil(totalProductCount.length / recordPerPage)

  const getDropdownData = (optionsArr, key, label) => {
    const arr = optionsArr?.map((item) => {
      return {
        key: item[key],
        label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
        value: item[key],
      };
    });
    arr.unshift({ key: "select", label: "Select", value: "" });
    return arr;
  };

  useEffect(() => {
    if (isOnline) {
      setShowOfflineText(false)
      getAccount();
    }
  }, [isOnline])
  useEffect(() => {
    candidateDetail[1].options = [];
    candidateDetail[2].options = [];
    const dateFormate = metaDataConstants.yearMonthDateFormat;
    const minDate = getDateWithFormat(dateFormate);
    setCurrent({
      ...current,
      inventorydate: minDate,
      inventorycounted: `${localStorage.getItem(
        "firstName"
      )} ${localStorage.getItem("lastName")}`,
    });
  }, []);


  const getAccount = async () => {
    const payload = {
      UserId: localStorage.getItem("userID"),
      IsActive: 1,
    };
    setActivateLoader(true);

    const response = await post(ApiUrls().ACCOUNT_BY_CURRENT_USER, payload).catch(
      function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      }
    );

    if (response?.status === 200) {
      console.log(response?.data);
      const data = response?.data.result;
      setAccountData(response?.data.result);
      const copyFormData = [...candidateDetail];
      copyFormData[0].options = getDropdownData(data, "id", "accountName");

      setCandidateDetail(copyFormData);
      getFiscalYear();
    } else {
      setActivateLoader(false);
    }
  };

  const getFiscalYear = async () => {
    const currentYear = new Date().getFullYear();
    const payload = {
      fiscalYear: currentYear + 1,
      isMonthFlag: 2,
    };
    const response = await post(ApiUrls().GET_FISCAL_WEEK, payload).catch(function (error) {
      // Handle errors here
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      setActivateLoader(false);
      console.log(response?.data);
      const currentDate = new Date();
      const data = response?.data.result.filter(
        (ele) =>
          currentDate > new Date(ele.startDate) &&
          currentDate < new Date(ele.endDate)
      );
      console.log(data);
      const dateFormate = "MM/dd/yyyy";
      const Start = data[0]?.startDate;
      const End = data[0]?.endDate;
      if (Start != undefined && End != undefined) {
        const Range = `${format(new Date(Start), dateFormate)} - ${format(
          new Date(End),
          dateFormate
        )}`;
        setStarDate(Range);
      }
    } else {
      setActivateLoader(false);
    }
  };
  const getStorage = async (locationId, dueDate) => {
    setActivateLoader(true);
    const payload = {
      AccountId: accounId,
      LocationId: locationId,
      IsActive: 1,
      dueDate: dueDate,
      take: 1000,
      skip: 0,
      Page: 1,

      PageSize: 1000,
    };
    setActivateLoader(true);
    const response = await post(ApiUrls().GET_INVENTORY_STORAGE, payload).catch(function (
      error
    ) {
      // Handle errors here
      setActivateLoader(false);
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      setActivateLoader(false);
      const data = response?.data.result;
      setStorageData(response?.data.result);
      const copyFormData = [...candidateDetail];
      copyFormData[2].options = getDropdownData(
        data,
        "storageCode",
        "storageName"
      );

      setCandidateDetail(copyFormData);
    } else {
      setActivateLoader(false);
    }
  };

  const getLocation = async (feq, accountId) => {
    let payload;

    let currentMonth = new Date().getMonth();

    let currentYear = new Date().getFullYear();

    //     let stringWithQuotes = startDate?startDate:null;
    // const stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');

    if (feq === "Monthly") {
      payload = {
        IsActive: 1,
        month: currentMonth + 1,
        year: currentYear,
        accountId: accountId,
        workflowModuleKey: "INVENTORY_COUNT_FILL",
        moduleKey: 1,
        masterId: accountId,
        timeOffset: -330,
        DateRange: null,
        take: 1000,
        skip: 0,
        page: 1,
        pageSize: 1000,
      };

      setActivateLoader(true);

      const response = await post(ApiUrls().GET_LOCATION, payload).catch(function (
        error
      ) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });

      if (response?.status === 200) {
        setActivateLoader(false);
        console.log(response?.data);
        setLocationData(response?.data.result);
        console.log(LocationData);
        const data = response?.data.result;
        const copyFormData = [...candidateDetail];
        copyFormData[1].options = getDropdownData(
          data,
          "locationId",
          "locationName"
        );

        setCandidateDetail(copyFormData);
        // alert("sucess");
      } else {
        setActivateLoader(false);
      }
    } else {
      payload = {
        IsActive: 1,
        month: currentMonth + 1,
        year: currentYear,
        accountId: accountId,
        workflowModuleKey: "INVENTORY_COUNT_FILL",
        moduleKey: 1,
        masterId: accountId,
        timeOffset: -330,
        DateRange: startDate,
        take: 1000,
        skip: 0,
        page: 1,
        pageSize: 1000,
      };
      setActivateLoader(true);
      const response = await post(ApiUrls().GET_LOCATION, payload).catch(function (
        error
      ) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });

      if (response?.status === 200) {
        setActivateLoader(false);
        console.log(response?.data);
        setLocationData(response?.data.result);
        console.log(LocationData);
        const data = response?.data.result;
        const copyFormData = [...candidateDetail];
        copyFormData[1].options = getDropdownData(
          data,
          "locationId",
          "locationName"
        );

        setCandidateDetail(copyFormData);
      } else {
        setActivateLoader(false);
      }
    }
  };

  const onSubmitHandler = async (model, anchor) => {
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }

    setActivateLoader(true);

    if (anchor) {
      setState({ ...state, [anchor]: false });
    }
    const accData = accountData?.filter((el) => el.id == model.account);
    const res = storageData?.filter(
      (ele) => ele.storageCode == model.storageArea
    );
    const filtData = candidateDetail[2].options.find(
      (item) => item.key == model.storageArea
    );
    const filtDataLocation = candidateDetail[1].options.find(
      (item) => item.key == model.location
    );
    const data = {
      locationName: filtDataLocation.label,
      storageName: filtData.label,
    };
    setLabelData({
      ...labelData,
      accountName: accData[0]?.accountName,
      locationName: filtDataLocation.label,
      storageName: filtData.label,
    });

    const payload = {
      AccountId: model.account,
      LocationId: model.location,
      LocationStorageId: res[0].locationStorageId,
      ProductName: "",
      IsActive: 1,
      InventoryCheckId: inventoryCheckId,
    };
    const response = await post(ApiUrls().ALL_PRODUCTS, payload).catch(function (error) {
      setActivateLoader(false);
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      setActivateLoader(false);

      setTotalProductCount(response?.data.result);
    } else {
      setActivateLoader(false);
    }
  };

  const onFilterChange = async (event, key, model) => {
    console.log(accountData);
    if (key === "account") {
      const accountId = event.target.value;
      setCurrent({
        ...current,
        account: accountId,
        location: "",
        storageArea: "",
      });
      setAccountId(accountId);
      const res = accountData?.filter((ele) => ele.id == accountId);
      const feq = res[0].inventoryFrequencyMetadataName;
      const copyFormData = [...candidateDetail];
      copyFormData[2].options = [{ key: "Select", label: "Select", value: "" }];
      setCandidateDetail(copyFormData);
      getLocation(feq, accountId);
    }
    if (key === "location") {
      const locationId = event.target.value;
      const res = LocationData?.filter((ele) => ele.locationId == locationId);
      setCurrent({
        ...current,
        location: locationId,
        inventoryduedate: res[0]?.dueDate?.slice(0, 10),
        storageArea: "",
      });
      setInventoryCheckId(res[0]?.id);
      getStorage(locationId, res[0]?.dueDate);
    }
    if (key === "storageArea") {
      setCurrent({
        ...current,
        storageArea: event.target.value
      });
    }
  };
  return (
    <div className="container containerMainDiv">
      <div className="contentdivBg pt-0">
        <div className="divRound pt-4">
          {showOfflineText ? <p style={{ marginTop: "10%", color: "red" }}>{metaDataConstants.youAreOffline}</p> : null}
          <h3 className="form-title">{metaDataConstants.invertoryRecords}</h3>
          <div className="activityList" style={{ margin: "0" }}>
            <div className="tabBox"></div>
            <Grid className="activiPad0" container columns={{ xs: 4, md: 12 }}>
              <Grid item xs={12} md={9} className="leftCol">
                <Grid spacing={3} container textalign="left" className="mr-3">
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.accountLabel}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.accountName ? labelData.accountName : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.locationLabel}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.locationName ? labelData.locationName : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.storageAreaLabel}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.storageName ? labelData.storageName : null}
                      </span>
                    </div>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={5}
                  textalign="left"
                  className="p-2 mt-2 productListDiv"
                >
                  {totalProductCount?.slice(coursesVisited, coursesVisited + recordPerPage).map((item) => {
                    return (
                      <Grid item xs={12} md={4}>
                        <Grid
                          container
                          alignItems="center"
                          spacing={3}
                          style={{ position: "relative" }}
                          className="cardBoxAcivity"
                        >
                          <Paper className={classes.paper}>
                            <Grid item xs={12}>
                              <Grid container spacing={3} className="cardTop">
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h5"
                                    component="h2"
                                    className={classes.heading}
                                  >
                                    <b className="mobHeader">{metaDataConstants.productNumberLabel}</b>
                                    <span className="branchName">
                                      {item.productCode}
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={5} className="buttonBox">
                                </Grid>
                              </Grid>
                              <Grid container className="labelGroup">
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.productNameLabel}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.productName}
                                    </span>
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.unit1} {item.uomName1}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.uomEnteredStock1}
                                    </span>
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.unit2} {item.uomName2}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.uomEnteredStock2}
                                    </span>
                                  </span>
                                </Grid>

                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.unit3} {item.uomName3}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.uomEnteredStock3}
                                    </span>
                                  </span>
                                </Grid>

                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.unitTotalQuantityLabel} {item.unitTotalQuantityUOMCode}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className={classes.subHeadingBold}>
                                    {item.unitTotalQuantity}
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
                <div>
                  {
                    totalProductCount.length > 9 ? <Pagination count={coursePages} defaultPage={1} onChange={(e, value) => { setPageNumber(value) }} /> : null
                  }
                </div>
              </Grid>
              <Grid item xs={12} md={3} className="rightCol">
                <div className={classes.desktopFilter}>
                  <div className="filterBox ml-3">
                    <h4 className="filterSec">
                      {" "}
                      <FilterAltIcon className="icnFilter" /> {metaDataConstants.filterBy}
                    </h4>
                    <DynamicForm
                      key={"filterId"}
                      title={" "}
                      buttonSubmit={metaDataConstants.filterBy}
                      defaultValues={current}
                      model={FILTER_FORM}
                      onSubmit={(model) => {
                        onSubmitHandler(model);
                      }}
                      disableSubmitOnInValid={false}
                      design="bootrstap" // material/bootrstap/advanceMaterial/advanceBootstrap
                      materialOutline={false}
                      onChange={(event, key) => onFilterChange(event, key)}
                      showAstersikOnRequiredFields={true}
                      className="activityFilters"
                      extaraActionFormButton={
                        <span className="reset" onClick={resetFilters}>
                          <RestartAltIcon /> {metaDataConstants.reset}
                        </span>
                      }
                    />
                  </div>
                </div>
                <span className={classes.drawerMobile}>
                  {["right"].map((anchor) => (
                    <React.Fragment key={anchor}>
                      <Box
                        className="editBtn"
                        sx={{ "& > :not(style)": { m: 1 } }}
                        onClick={toggleDrawer(anchor, true)}
                      >
                        <span className="icnFilterBox">
                          {" "}
                          {metaDataConstants.filterBy}
                          <FilterAltIcon />{" "}
                        </span>
                      </Box>
                      <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                      >
                        <div className="filterBox">
                          <h4 className="filterSec">
                            <FilterAltIcon className="icnFilter" /> {metaDataConstants.filterBy}{" "}
                            <span
                              style={{ float: "right" }}
                              onClick={toggleDrawer(anchor, false)}
                            >
                              <CloseIcon />
                            </span>
                          </h4>
                          <DynamicForm
                            key={"filterId"}
                            title={" "}
                            buttonSubmit={"APPLY FILTER"}
                            defaultValues={current}
                            model={FILTER_FORM}
                            onSubmit={(model) => {
                              onSubmitHandler(model, anchor);
                            }}
                            disableSubmitOnInValid={false}
                            design="bootrstap" // material/bootrstap/advanceMaterial/advanceBootstrap
                            materialOutline={false}
                            onChange={(event, key) =>
                              onFilterChange(event, key)
                            }
                            showAstersikOnRequiredFields={true}
                            className="activityFilters activityFiltersMobile"
                            extaraActionFormButton={
                              <span
                                className="reset"
                                onClick={() => resetFilters(anchor)}
                                style={{ marginRight: 15 }}
                              >
                                <RestartAltIcon /> {metaDataConstants.reset}
                              </span>
                            }
                          />
                          <Loader active={activateLoader} />
                        </div>
                      </SwipeableDrawer>
                    </React.Fragment>
                  ))}
                </span>
              </Grid>
            </Grid>
            <div>
              <Loader active={activateLoader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductListing;
